import React from 'react';
import CareerMentorshipContainer from '../../../Containers/UserContainer/CareerMentorship';

const CareerMentorshipScreen = () => {
  return <CareerMentorshipContainer />;
};

export default CareerMentorshipScreen;
